<template>
  <div>
    <v-container>
      <refinery-banner />
    </v-container>
    <router-view></router-view>
  </div>
</template>

<script>
import RefineryBanner from '@/components/refinery/RefineryBanner'

export default {
  name: 'RefineryRouteWrapper',
  components: {
    RefineryBanner,
  },
}
</script>

<style></style>
